export const VolunteerListWithPaggination = (state) => {
    return state?.volunteers?.volunteers;
};
export const VolunteerIsLoading = (state) => {
    return state?.volunteers?.showLoading;
};
